"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AcademicProgramsGrid() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257912" id="שירותים-סיעודיים-בפתח-תקווה" ref={sectionRef} className="relative w-full bg-background py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-muted/30 -z-10 [clip-path:polygon(100%_0,0_0,100%_100%)]" aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-48 h-48 md:w-80 md:h-80 bg-accent -z-10 [clip-path:polygon(0_100%,0_0,100%_100%)]" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        {}
        <div className={`mb-12 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`}>
          <Link to="/HomePage" className="inline-block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_logo.png" alt="שירותי סיעוד פתח תקווה" className="h-20 md:h-24 w-auto object-contain" />
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div className={`lg:col-span-7 xl:col-span-8 space-y-8 transition-all duration-700 delay-100 transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <header className="space-y-2">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary uppercase tracking-tight font-default">
                שירותי סיעוד מקצועיים
              </h2>
              <p className="text-xl md:text-2xl text-foreground/80 font-light">
                מעטפת טיפולית מקיפה בפתח תקווה והסביבה
              </p>
            </header>

            <div className="space-y-6 text-base md:text-lg text-foreground/80 leading-relaxed">
              <h3 className="text-2xl md:text-3xl font-bold text-primary font-default">
                טיפול מסור בבית הלקוח
              </h3>
              <p>
                אנו מספקים שירותי סיעוד וליווי מקצועי בפתח תקווה, המותאמים אישית לצרכי המטופל ומשפחתו. הצוות שלנו מורכב ממטפלים מוסמכים ומנוסים המתמחים בסיעוד ביתי, ליווי לאחר אשפוז ותמיכה בחולים כרוניים. אנו מבינים את החשיבות של סביבה מוכרת ותומכת להחלמה ולשמירה על איכות חיים, ולכן אנו מביאים את הטיפול המקצועי ביותר ישירות אליכם הביתה, תוך הקפדה על יחס אישי, כבוד ורגישות לכל אורך הדרך.
              </p>
              <p>
                השירותים שלנו כוללים השגחה צמודה, סיוע בפעולות יומיומיות, ניהול תרופתי וליווי רפואי מקצועי. בנוסף, אנו מציעים שירותי "הפוגה" למשפחות המטפלות, המאפשרים לבני המשפחה לקחת פסק זמן נחוץ בידיעה שיקיריהם נמצאים בידיים הבטוחות והמקצועיות ביותר. בין אם מדובר בטיפול זמני לאחר ניתוח או בליווי ארוך טווח, אנו כאן כדי להעניק לכם שקט נפשי וביטחון רפואי. למידע נוסף על <Link to="/CaregiverServicePagesPage" className="text-primary font-semibold underline">מגוון שירותי המטפלים</Link> שלנו או לתיאום <Link to="/NursingCareProviderPetahTikvaWithinHoursPage" className="text-primary font-semibold underline">שירות מיידי בפתח תקווה</Link>, צרו עמנו קשר עוד היום.
              </p>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 xl:col-span-4 transition-all duration-700 delay-300 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Card className="bg-primary text-primary-foreground border-none shadow-xl rounded-lg overflow-hidden sticky top-24">
              <div className="p-4 md:p-6 pb-0">
                <div className="bg-background/10 p-2 rounded-md backdrop-blur-sm">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_director.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_director.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_director.png-wvc-sizes" alt="מנהלת שירותי סיעוד" className="w-full h-auto object-cover rounded-md shadow-md" loading="lazy" />
                </div>
              </div>
              <CardContent className="p-6 md:p-8 text-center space-y-4">
                <h4 className="text-2xl md:text-3xl font-bold font-default tracking-wide">
                  דבורה לוי
                </h4>
                <div className="space-y-1.5 text-sm md:text-base text-primary-foreground/90">
                  <p className="font-semibold uppercase tracking-wider text-xs md:text-sm text-secondary">
                    מנהלת מקצועית - שירותי סיעוד פתח תקווה
                  </p>
                  <p className="font-medium">אחות מוסמכת (RN), מומחית בגריאטריה</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}